import { ROLLOUT_WAVEFORM } from 'constants/featureFlag';
import { UserPropertyEnum } from 'constants/userProperties';

import { useFlagIsActivated } from 'hooks/featureFlag';
import { useUserProperty } from 'hooks/userProperties';

export const useShouldShowWaveform = (): boolean => {
  const { value: shouldConsiderForWaveformExp } = useUserProperty(
    UserPropertyEnum.CONSIDER_FOR_WAVEFORM_EXP
  );

  const isInWaveformFlag = useFlagIsActivated({
    flag: ROLLOUT_WAVEFORM,
    activationValues: ['show-new'],
    skipLoggingToSegment: true,
    eligibilityPreCheckFunction: () => {
      return {
        pass: shouldConsiderForWaveformExp || false,
        failReason: 'Should not consider user for waveform experiment',
      };
    },
  });

  if (!shouldConsiderForWaveformExp) {
    return false;
  }

  return isInWaveformFlag;
};
